import axiosInstance from '@/api/axios'

// 注销账号
export function cancelAccountApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/cancelAccount',
        method: 'post',
        data: parameter,
    })
}
